const addProductForm = document.querySelectorAll('form[action="/cart/add"]')
const mainCart = document.getElementById('main-cart')
const miniCart = document.getElementById('mini-cart-overlay')
const miniCartOverlay = document.getElementById('mini-cart')

if (addProductForm.length)
  addProductForm.forEach((element) =>
    element.addEventListener('submit', (e) => {
      // prevent default shopify add to cart functionality
      e.preventDefault()
      e.stopPropagation()

      e.target.querySelector('button[type="submit"] > span').textContent =
        'Adding to cart'
      e.target.querySelector('button[type="submit"]').classList.add('added')
      e.target.querySelector(
        'button[type="submit"] > svg.cart-icon'
      ).style.display = 'none'
      e.target.querySelector(
        'button[type="submit"] > svg.loading-icon'
      ).style.display = 'block'

      let formData = new FormData(element)
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          return response.json()
        })
        .then(() => {
          //console.log(formData);
          // This is the  from our response
          if (mainCart) mainCart.classList.add('added')
          if (miniCart) miniCart.classList.add('open')
          if (miniCartOverlay) miniCartOverlay.classList.add('open')

          e.target.querySelector('button[type="submit"] > span').textContent =
            'Added to cart'
          e.target
            .querySelector('button[type="submit"]')
            .classList.remove('added')
          e.target
            .querySelector('button[type="submit"]')
            .classList.add('successful')
          e.target.querySelector(
            'button[type="submit"] > svg.cart-icon'
          ).style.display = 'block'
          e.target.querySelector(
            'button[type="submit"] > svg.loading-icon'
          ).style.display = 'none'
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    })
  )
